import {ReportContextValue} from '../../../state/reports/context';

export const TEAM_README_CONTEXT_VALUE: ReportContextValue = {
  disableComments: true,
  disableCopyLinkToSection: true,
  disablePanels: true,
  disableTableOfContents: true,
  disableLinkToReport: true,
  disablePersistentTopLine: true,
};
